import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import WhyChooseUs from './components/WhyChooseUs';
import Gallery from './components/Gallery';
import Admissions from './components/Admissions';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="bg-white">
      <Navbar />
      <Hero />
      <About />
      <Programs />
      <WhyChooseUs />
      <Gallery />
      <Admissions />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
